<template>
    
    

    <div class="container infopages pt-3">

        <div v-if="isShow">
            <bootstrap-alert 
                :variant="response.variant" 
                :msg="response.message" 
                :errorMsg="response.errmsg"
            />
        </div>

        <div v-if="loading" class="loading"></div>

        <h1 v-if="cmsPageContent && cmsPageContent.translations">{{cmsPageContent.translations[0].title}}</h1>
        <p v-if="cmsPageContent && cmsPageContent.translations">{{cmsPageContent.translations[0].summary}}</p>
        <div class="ql-editor" v-html="cmsPageContent.translations[0].content"></div>
        <vue-editor style="display:none" />

        <!-- <div>
            <h1 v-if="cmsPageContent && cmsPageContent.translations">{{cmsPageContent.translations[0].title}}</h1>
            <p v-if="cmsPageContent && cmsPageContent.translations">{{cmsPageContent.translations[0].summary}}</p>
            <p v-if="cmsPageContent && cmsPageContent.translations"><div v-html="cmsPageContent.translations[0].content"></div></p>
        </div> -->

        <!-- <div>
            <div class="shop-left-sidebar terms-section">
                <h4 class="mb-30 mt-4">Privacy Policy</h4>
                <b-card>
                    <div v-if="!loading">
                        <b-card-text v-if="warrantyTermsConditions">
                            <div class="wrapper terms-conditions" v-html="warrantyTermsConditions"></div>
                        </b-card-text> 
                        <b-card-text v-else>
                            <div class="wrapper terms-conditions">{{ $t("No document found") }}</div>
                        </b-card-text> 
                    </div>
                    <div v-else class="loader"></div>
                    <div v-else><b-spinner style="text-align:center" small></b-spinner></div>

                </b-card>
            </div>
        </div> -->
        
    </div>

    
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { VueEditor } from "vue2-editor"

export default {
    components: { VueEditor },
    metaInfo() {
        return {
            title: this.cmsPageContent.title,
            meta: [
                { charset: 'utf-8' },
                { name: 'title', content: this.cmsPageContent.title},
                { name: 'description', content: (this.cmsPageContent.meta_desc) ? this.cmsPageContent.meta_desc : this.cmsPageContent.title},
                { name: 'keywords', content: this.cmsPageContent.title + ', renkaatalle, Renkaatalle.fi'},
                { name: 'robots', content: 'index,follow'}
            ]
        }
    },
    data() {
        return {
            pageUrl: ""
        }
    },
    computed: {
        ...mapGetters("cmspage", ["cmsPageContent", "loading", 'response', 'isShow']),
        ...mapGetters('app', ['currentLang']),
    },
    watch: {
        '$route.params': {
            handler(newValue, oldValue) {

                this.pageUrl = newValue.pagepath;
                this.getCmsPageContent({pageName:  this.pageUrl, lang: (this.currentLang == "fi_FI" ? 2 : 1)})
            }
            ,immediate: true
        },
        currentLang: {
            handler(newValue, oldValue) {

                this.pageUrl = newValue.pagepath;
                this.getCmsPageContent({pageName:  this.$route.params.pagepath, lang: (this.currentLang == "fi_FI" ? 2 : 1)})
            }
        }
    },
    methods: {
        ...mapActions("cmspage", ["getCmsPageContent"]),
    },
}
</script>